export default __webpack_public_path__ + "static/media/D036_tn.24dfbd30.jpg";